import { render, staticRenderFns } from "./canal-anonimo.vue?vue&type=template&id=6b76d2e8&scoped=true"
import script from "./canal-anonimo.vue?vue&type=script&lang=js"
export * from "./canal-anonimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76d2e8",
  null
  
)

export default component.exports